<template>
  <div class="table-responsive agreement-table">
    <table class="table table-striped table-bordered">
      <thead v-if="agreementRules.length">
        <tr>
          <th v-if="hasLevel">
            Level
          </th>
          <th v-if="hasDebtType">
            Tipo de dívida
          </th>
          <th v-if="hasAgreementType">
            Tipo de acordo
          </th>
          <th v-if="hasAdmissionPercentage">
            Obrigatoriedade de entrada %
          </th>
          <th v-if="hasExemptChargesType">
            Isenção de juros e multa
          </th>
          <th v-if="hasAllowsRedoAgreements">
            Reacordo?
          </th>
          <th v-if="hasConcessionRule">
            Qtde. bills pendente
          </th>
          <th v-if="hasDebtAging">
            Aging da dívida
          </th>
          <th v-if="hasInstallmentsLimit">
            Quantidade de parcelas a fazer
          </th>
          <th v-if="hasInstallmentsType">
            Especificação das parcelas
          </th>
          <th v-if="hasMinimumAmount">
            Valor mín
          </th>
          <th v-if="hasMaximumAmount">
            Valor max
          </th>
          <th v-if="hasPenaltyPercentage">
            Multa %
          </th>
          <th v-if="hasDiscountPercentage">
            Desconto
          </th>
          <th v-if="hasExpiryDays">
            Validade do acordo
          </th>
          <th v-if="hasObservations">
            Observações
          </th>
          <th v-if="!readOnly"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="!agreementRules.length">
          <td>
            Não há regras de acordo para exibir
          </td>
        </tr>
        <tr
          v-for="(agreementRule, index) in agreementRules"
          :key="index"
          :class="{ success: agreementRule.newAgreementRule }"
        >
          <td v-if="hasLevel">
            {{ optionName(agreementRule.level) }}
          </td>
          <td v-if="hasDebtType">
            {{ optionLabel(agreementRule.debt_type) }}
          </td>
          <td v-if="hasAgreementType">
            {{ optionLabel(agreementRule.agreement_type) }}
          </td>
          <td v-if="hasAdmissionPercentage">
            {{ agreementRule.admission_percentage }}
          </td>
          <td v-if="hasExemptChargesType">
            {{ optionLabel(agreementRule.exempt_charges_type) }}
          </td>
          <td v-if="hasAllowsRedoAgreements">
            {{ redoAgreementText(agreementRule.allows_redo_agreements) }}
          </td>
          <td v-if="hasConcessionRule">
            {{ concessionRuleText(agreementRule) }}
          </td>
          <td v-if="hasDebtAging">
            {{ optionLabel(agreementRule.debt_aging) }}
          </td>
          <td v-if="hasInstallmentsLimit">
            {{ agreementRule.installments_limit }}
          </td>
          <td v-if="hasInstallmentsType">
            {{ optionLabel(agreementRule.installments_type) }}
          </td>
          <td v-if="hasMinimumAmount">
            {{ agreementRule.minimum_amount }}
          </td>
          <td v-if="hasMaximumAmount">
            {{ agreementRule.maximum_amount }}
          </td>
          <td v-if="hasPenaltyPercentage">
            {{ agreementRule.penalty_percentage }}
          </td>
          <td v-if="hasDiscountPercentage">
            {{ agreementRule.discount_percentage }}
          </td>
          <td v-if="hasExpiryDays">
            {{ agreementRule.expiry_days }}
          </td>
          <td v-if="hasObservations">
            {{ agreementRule.observations }}
          </td>
          <td v-if="!readOnly">
            <button
              class="btn btn-danger glyphicon glyphicon-trash"
              @click="selectAgreementRuleForDelete(agreementRule)"
            ></button>
          </td>
        </tr>
      </tbody>
    </table>
    <confirm-modal v-if="showConfirmModal" @close="showConfirmModal = false;" @confirm="deleteAgreementRule()" />
  </div>
</template>
<style lang="scss" scoped>
  .agreement-table {
    max-height: 500px;
  }
</style>
<script>
import DebtAgreementRulesService from 'services/DebtAgreementRulesService';
import ConfirmModal from 'components/ConfirmModal';

export default {
  components: {
    ConfirmModal,
  },
  props: {
    agreementRules: {
      type: Array,
      default: () => [],
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showConfirmModal: false,
      selectedAgreementRule: null,
    };
  },
  computed: {
    hasLevel() {
      return this.agreementRules.filter(rule => rule.level_id).length;
    },
    hasDebtType() {
      return this.agreementRules.filter(rule => rule.debt_type).length;
    },
    hasAgreementType() {
      return this.agreementRules.filter(rule => rule.agreement_type).length;
    },
    hasAdmissionPercentage() {
      return this.agreementRules.filter(rule => rule.admission_percentage).length;
    },
    hasExemptChargesType() {
      return this.agreementRules.filter(rule => rule.exempt_charges_type).length;
    },
    hasAllowsRedoAgreements() {
      return this.agreementRules.filter(rule => (
        rule.allows_redo_agreements === false || rule.allows_redo_agreements === true
      )).length;
    },
    hasConcessionRule() {
      return this.agreementRules.filter(rule => rule.concession_rule).length;
    },
    hasDebtAging() {
      return this.agreementRules.filter(rule => rule.debt_aging).length;
    },
    hasInstallmentsLimit() {
      return this.agreementRules.filter(rule => rule.installments_limit).length;
    },
    hasInstallmentsType() {
      return this.agreementRules.filter(rule => rule.installments_type).length;
    },
    hasMinimumAmount() {
      return this.agreementRules.filter(rule => rule.minimum_amount).length;
    },
    hasMaximumAmount() {
      return this.agreementRules.filter(rule => rule.maximum_amount).length;
    },
    hasPenaltyPercentage() {
      return this.agreementRules.filter(rule => rule.penalty_percentage).length;
    },
    hasDiscountPercentage() {
      return this.agreementRules.filter(rule => rule.discount_percentage).length;
    },
    hasExpiryDays() {
      return this.agreementRules.filter(rule => rule.expiry_days).length;
    },
    hasObservations() {
      return this.agreementRules.filter(rule => rule.observations).length;
    },
  },
  methods: {
    concessionRuleText(agreementRule) {
      return (
        agreementRule.concession_rule ? (
          `${agreementRule.concession_rule.label} ${agreementRule.concession_value}`
        ) : ''
      );
    },
    redoAgreementText(allowsRedoAgreements) {
      // eslint-disable-next-line no-nested-ternary
      return allowsRedoAgreements === true ? 'Sim' : (allowsRedoAgreements === false ? 'Não' : '');
    },
    optionLabel(option) {
      return option ? option.label : '';
    },
    optionName(option) {
      return option ? option.name : '';
    },
    selectAgreementRuleForDelete(agreementRule) {
      this.selectedAgreementRule = agreementRule;
      this.showConfirmModal = true;
    },
    deleteAgreementRule() {
      this.$loader.show();
      DebtAgreementRulesService.disableAgreementRule(this.selectedAgreementRule.id)
        .then(() => {
          this.$emit('agreement-rule-deleted', this.agreementRules.indexOf(this.selectedAgreementRule));
          this.$alert.notifySuccess('Regra de acordo excluida com sucesso.');
        })
        .catch(() => {
          this.$alert.notifyAlert('Erro ao excluir regra de acordo, tente novamente mais tarde');
        })
        .finally(() => {
          this.showConfirmModal = false;
          this.$loader.hide();
        });
    },
  },
};
</script>
